import { useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../../constants/apiConfig";
import { useNavigate } from "react-router-dom";
import LoginContext from "../LoginContext";

const DailyAssignments = () => {
  const [assignments, setAssignments] = useState([]);
    const navigate = useNavigate();
  const { userId }: any = useContext(LoginContext);
  
  

  const actionHandler = (test_id: number, is_completed: boolean) => {
    if(!is_completed) {
    navigate(`/genQus?test_id=${test_id}`);
    }
  }

  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/dailyAssignments?user_id=${userId}`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data: any) => {
        setAssignments(data.assignments || []);
      })
      .catch((error) => {
        console.error("Error fetching assignments:", error);
      });
  }, [userId]);

  return (
    <div className="overflow-x-auto w-full bg-base-100 shadow-md rounded-lg mt-6">
      <table className="table w-full">
        <thead>
          <tr>
            <th>Test ID</th>
            <th>Score</th>
            <th>Status</th>
            <th>Assigned Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((item: any) => (
            <tr key={item.test_id} className="hover">
              <td>{item.test_id}</td>
              <td>{item.total_score}</td>
              <td>
                <span className={`badge badge-sm ${item.is_completed ? 'badge-success' : 'badge-warning'}`}>
                  {item.is_completed ? 'Completed' : 'Pending'}
                </span>
              </td>
              <td>{new Date(item.assigned_date).toLocaleDateString()}</td>
              <td>
                <button className="btn btn-xs btn-outline btn-primary" onClick={() => actionHandler(item.test_id, item.is_completed)}>
                  {item.is_completed ? 'Review' : 'Start Test'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DailyAssignments;
